import Cookies from 'js-cookie';
import axios from '@/utils/axios-instance';

export default async function() {
    let jwt = Cookies.get('b2b_bearer')

    if(!jwt) {
        return false;
    }

    try {
        let response = await axios.get('login/is-logged-in');
        return response.data.logged_in;
    } catch(error) {
        return false;
    }
}